var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'general')?_c('b-card',{staticClass:"m-t-15 m-b-15 s-1",attrs:{"header":"Datos del usuario"}},[_c('model-form',{attrs:{"input_full_width":"","show_btn_delete":false,"model":_vm.user,"properties":_vm.modelPropertiesFromName('user'),"model_name":"user"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }